import React from "react";
import Header from "~/components/layout/Header";
import SideBar from "~/components/layout/Sidebar";
import portalDeCompras from "./assets/images/portal_de_compras.png";
import subsidio from "./assets/images/subsidio.png";
import parcerias from "./assets/images/parcerias.png";
import OpenChatBot from '~/components/layout/Chatbot';

import { useSelector } from "react-redux";

import {
  PageContainer,
  Container,
  Content,
  HeaderContainer,
  PageWrapper,
  ClubImageContainer,
  ClubImage,
  MobileImage,
  ClubImageSectionOne,
  SubsidioImage,
  ClubImageSectionTwo,
  PortalImage
} from "./styles";

export default function ShoppingClub() {

  const classificationReducer = useSelector(state => state.classificationReducer);

  return (
    <PageContainer>
      <div className="mobile">
        <SideBar
            menuSelected={"Portal de Compras"}
            hasPendenciOn={classificationReducer.pendenciesOn}
          >
          <Container>
            <Content>
              <HeaderContainer>
                <Header />
              </HeaderContainer>
              <PageWrapper>
                <MobileImage>
                  <ClubImageContainer>
                    <PortalImage alt="Banner portal de compras" src={portalDeCompras} />
                    <SubsidioImage alt="Programa de Subsídio" src={subsidio} />
                     <a href="https://app.pipefy.com/organizations/300880142/interfaces/c1681f98-cd74-4977-8dd8-26fef32b18bd" target="_blank">
                      <ClubImage alt="Parcerias" src={parcerias} />
                     </a>
                  </ClubImageContainer>
                </MobileImage>
              </PageWrapper>
            </Content>
          </Container>
           <OpenChatBot />
        </SideBar>
      </div>
      <div className="desktop">
        <SideBar
          menuSelected={"Portal de Compras"}
          hasPendenciOn={classificationReducer.pendenciesOn}
        >
          <Container>
            <Content>
              <HeaderContainer>
                <Header />
              </HeaderContainer>
                <PageWrapper>
                  <ClubImageSectionOne>
                    <PortalImage alt="Banner portal de compras" src={portalDeCompras} />
                    <SubsidioImage alt="Programa de Subsídio" src={subsidio} />
                  </ClubImageSectionOne>
                  <ClubImageSectionTwo>
                     <a href="https://app.pipefy.com/organizations/300880142/interfaces/c1681f98-cd74-4977-8dd8-26fef32b18bd" target="_blank">
                      <ClubImage alt="Parcerias" src={parcerias} />
                     </a>
                  </ClubImageSectionTwo>
                </PageWrapper>
            </Content>
          </Container>
          <OpenChatBot />
        </SideBar>
      </div>
    </PageContainer>
  );
}
